module.exports = __webpack_public_path__ + "static/media/himfooter.46a387e2.jpg";